import * as utils from './index'

import Vue from 'vue'

Object.keys(utils).forEach(key => {
  Vue.filter(key, utils[key])
})

Object.keys(utils).forEach(key => {
  Vue.prototype[key] = utils[key]
})

